<!--Copy right - © 2024 tecera gmbh-->
<script>    
    export let device_search_input;
    export let placeholder = "Suche";
</script>


<div class="input-group mb-2">
    <button
        class="btn btn-search-hymo pl-2 no_pointer"
                style="border-top-right-radius: 0;
        border-bottom-right-radius: 0;"
    >
        <i class="fa fa-search search-hymo"
        ></i>
    </button>

    <input
        bind:value={device_search_input}
        id="waechter_suche"
        class="form-control py-1"
        style="border: none; box-shadow: none; border-top-left-radius: 0;
        border-bottom-left-radius: 0;border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;"
        type="text"
        placeholder={placeholder}
        aria-label="Search"
        maxlength="50"
        autocomplete="off"
    />

    <button
        class="btn bg-transparent btn-clear"
        class:hidden={device_search_input == ""}
        on:click={() => (device_search_input = "")}

    >
        <i class="fa fa-times"></i>
    </button>

</div>